import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const StyledEmailLink = styled(Box)({
  fontWeight: 600,
  cursor: 'pointer',
  color: 'inherit',
  '&:hover': {
    opacity: 0.8,
  },
  '&:focus': {
    outlineOffset: '2px',
  },
});
